import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, DestroyRef, inject, OnInit, ViewChild, Inject } from '@angular/core';
import { AccountBilling } from '../../gdo-shared/Models/account-billing';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppliedFilters } from '../../gdo-shared/Models/Models';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { PaymentService } from 'src/app/payment/payment.service';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { MatTableDataSource } from '@angular/material/table';
import {
  Transaction_Types,
  transformIntoApiCallObj,
  transformIntoApiCallObjWithoutClientId,
} from '../../gdo-shared/Models/Constants';
// import { GdoAdvancedFilterationOptionsComponent } from './gdo-advanced-filteration-options/gdo-advanced-filteration-options.component';
import { ViewInvoiceComponent } from 'src/app/payment/account-billing-hostory/view-invoice/view-invoice.component';
import { DOCUMENT } from '@angular/common';
import { AdvancedFilterationOptionsComponent } from 'src/app/payment/account-billing-hostory/advanced-filteration-options/advanced-filteration-options.component';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { GdoAdvancedFilterationOptionsComponent } from '../../gdo-desktop/gdo-payment/gdo-payment-components/gdo-account-billing-history/gdo-advanced-filteration-options/gdo-advanced-filteration-options.component';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-gdo-billing-history-webview',
    templateUrl: './gdo-billing-history-webview.component.html',
    styleUrls: ['./gdo-billing-history-webview.component.scss'],
    standalone: false
})
export class GdoBillingHistoryWebviewComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  student: AccountBilling[] = [];
  // columns we will show on the table
  // public displayedColumns = [
  //   'date',
  //   'type',
  //   'desc',
  //   'amount',
  //   'action',
  // ];

  filterForm!: UntypedFormGroup;
  AdFilter: boolean = false;
  filterTypes = [
    { value: 'Last 6 Months' },
    { value: 'Last Year' },
    { value: 'Custom Range' },
  ];

  @ViewChild('picker')
  datePicker!: MatDateRangePicker<Date>;
  dateFilter: string = 'dateFilter';

  //displayedColumns: string[] = ['date', 'transactionType', 'amount', 'description', 'action'];
  displayedColumns: string[] = ['description', 'amount', 'action'];
  totalData: AccountBilling[] = [];
  filteredData: AccountBilling[] = [];
  dataSource: any;
  showBox: boolean = false;
  isAcura: boolean = false;
  datesList: string[] = [];
  newDatesList: string[] = [];
  defaultFilterType = 'Last Year';
  appliedAdvanceFilters: AppliedFilters | null = null;
  //Date_data:TransHistory={};
  //groupingColumn: string = this.Date_data.transaction_create_date;
  groupingColumn: any;
  reducedGroups = [];
  initialData: AccountBilling[] = [];
  viewReport: string = '';

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private paymentService: PaymentService,
    private dialog: MatDialog,
    private appService: AppService
  ) {
    //this.initialData = this.dataSource;
  }

  ngOnInit(): void {
    this.filterForm = this.formBuilder.group({
      filter_prov: [null],
    });

    this.setIsAcuraLocally();
    this.getBillingHistory();
  }

  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }

  getMonthDifference(date: string | number | Date | undefined) {
    //
    const currentDate = new Date();
    var previousDate = new Date(date ?? '');
    return (
      currentDate.getMonth() -
      previousDate.getMonth() +
      12 * (currentDate.getFullYear() - previousDate.getFullYear())
    );
  }

  ngAfterViewInit() {
    //this.callPagerAndSort();
    //
  }

  trackByFilterType(index: number, type: { value: string }): string {
    return type.value;
  }

  trackByBillingGroup(index: number, records: any[]): string | number {
    return records?.[0]?.key || index;
  }

  trackByBillingRecord(index: number, record: AccountBilling): string | number {
    return record?.invoiceNo || record?.action || `${record?.date || ''}-${record?.type || ''}-${record?.amount || ''}-${index}`;
  }

  callPagerAndSort() {
    //
    this.filteredData = this.filteredData.sort((a: AccountBilling, b: AccountBilling) => {
      //
      if (b.invoiceNo != null && a.invoiceNo != null && b.invoiceNo > a.invoiceNo) {
        return -1;
      } else return 1;
    });

    if (this.filteredData) {
      this.filteredData = this.filteredData.sort((a: AccountBilling, b: AccountBilling) => {
        //
        if (a.filterType == 'Invoice') {
          return -1;
        } else return 1;
      });
    }
    if (this.filteredData) {
      this.filteredData = this.filteredData.sort((a: AccountBilling, b: AccountBilling) => {
        //
        const dt1 = Date.parse(a.date);
        const dt2 = Date.parse(b.date);

        if (dt1 > dt2) return -1;
        if (dt1 < dt2) return 1;
        return 0;
      });
    }

    this.dataSource = this.GroupRowBy(this.filteredData);
    if (Array.isArray(this.dataSource) && this.dataSource.length > 0) {
      this.AdFilter = true;
    } else {
      this.AdFilter = false;
    }
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
    }
  }

  getBillingHistory() {
    // ;
    let data = {};
    data = transformIntoApiCallObj(data, 'get_acct_trans_history_m');
    this.appService.AriaPassThroughConnect(data).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      // ;
      if (res && res.error_code === 0 && res.error_msg === 'OK') {
        const rawData: TransHistory[] = res.history;
        const constructedData: AccountBilling[] = [];

        for (const iterator of rawData) {
          if (this.getMonthDifference(iterator.transaction_create_date) < 6) {
            this.defaultFilterType = 'Last 6 Months';
            break;
          }
        }

        this.filterForm.get('filter_prov')?.setValue(this.defaultFilterType);

        const inVoiceData = rawData.filter(
          (x) =>
            x.transaction_type === 21 ||
            x.transaction_type === -21 ||
            x.transaction_type === 22 ||
            x.transaction_type === -22 ||
            x.transaction_type === 1 ||
            x.transaction_type === -1
        );

        const payment = rawData.filter(
          (x) =>
            x.transaction_type != 21 &&
            x.transaction_type != 22 &&
            x.transaction_type != -22 &&
            x.transaction_type != -21 &&
            x.transaction_type != 1 &&
            x.transaction_type != -1 &&
            x.transaction_type != 8
        );
        // let refund = rawData.filter(x => x.transaction_type === 8);
        // var holder = {} as any;
        // const constructInvoiceData = [];
        // refund.forEach(function (d) {
        //   if (holder.hasOwnProperty(d.statement_no)) {
        //     holder[d.statement_no!] =
        //       holder[d.statement_no!] + d.transaction_amount;
        //   } else {
        //     holder[d.statement_no!] = d.transaction_amount!;
        //   }
        // });
        // for (var prop in holder) {
        //   const res = refund.filter(x => x.statement_no === Number(prop));
        //   const type = Transaction_Types.filter(x => x.value === res[0].transaction_type);
        //   constructInvoiceData.push({
        //     amount: holder[prop],
        //     date: res[0].transaction_create_date,
        //     desc: "Credit",
        //     type: type[0].displayValue,
        //     filterType: "Refund",
        //   });
        // }

        // constructedData.push(...constructInvoiceData);

        for (const iterator of payment) {
          let obj: AccountBilling = {} as AccountBilling;
          obj.date = iterator.transaction_create_date ?? '';
          obj.amount = iterator.transaction_amount + '';
          obj.desc = iterator.transaction_desc ?? '';

          if (
            iterator.transaction_type === 2 ||
            iterator.transaction_type === 3
          ) {
            obj.filterType = 'Payment';
          } else if (
            iterator.transaction_type === 13 ||
            iterator.transaction_type === -13 ||
            iterator.transaction_type === 20 ||
            iterator.transaction_type === -20
          ) {
            obj.filterType = 'Refund';
          } else if (
            iterator.transaction_type === 10 ||
            iterator.transaction_type === -10 ||
            iterator.transaction_type === 11 ||
            iterator.transaction_type === -11 ||
            iterator.transaction_type === 24 ||
            iterator.transaction_type === -24
          ) {
            obj.filterType = 'Credit';
          } else {
            const filterType = Transaction_Types.filter(
              (x) => x.value === iterator.transaction_type
            );
            obj.filterType = filterType[0].displayValue;
          }

          const type = Transaction_Types.filter(
            (x) => x.value === iterator.transaction_type
          );
          obj.type = type[0].displayValue;

          obj.action = iterator.statement_no + '';
          obj.invoiceNo = iterator.invoice_no ?? undefined;

          constructedData.push(obj);
        }

        this.totalData = constructedData;

        this.dateFilterClick();

        this.callPagerAndSort();
        this.fetchInvoiceData(inVoiceData);
      }
    });
  }

  fetchInvoiceData(inVoiceData: TransHistory[]) {
    //  Updating the display logic so that only invoices that equal zero due to invoice line items(i.e type 21) all being zero are removed from the display.
    var holder = {} as any;
    inVoiceData.forEach((d: TransHistory) => {
      let showRecord = true;
      if (holder.hasOwnProperty(d.invoice_no)) {
        if (
          d.transaction_type === 21 &&
          d.transaction_amount === 0 &&
          !holder[d.invoice_no!].displayRecord
        ) {
          showRecord = false;
        }
        holder[d.invoice_no!] = {
          amount: holder[d.invoice_no!].amount + d.transaction_amount,
          displayRecord: showRecord,
        };
      } else {
        if (d.transaction_type === 21 && d.transaction_amount === 0) {
          showRecord = false;
        }
        holder[d.invoice_no!] = {
          amount: d.transaction_amount!,
          // displayRecord: d.displayRecord ? d.displayRecord : false,
          displayRecord: showRecord,
        };
      }
    });
    const constructInvoiceData: AccountBilling[] = [];

    const promiseArray: Promise<any>[] = [];

    for (var prop in holder) {
      const res = inVoiceData.filter((x) => x.invoice_no === Number(prop));

      const type = Transaction_Types.filter(
        (x) => x.value === res[0].transaction_type
      );

      // Elimenate 0 amount records considering them as trial invoices
      // if(holder[prop] !== 0){
      if (holder[prop].displayRecord) {
        constructInvoiceData.push({
          amount: holder[prop].amount.toFixed(2),
          date: res[0].transaction_create_date ?? '',
          desc: '',
          // type: type[0].displayValue,
          type: 'Invoice',
          paymentMethod: 'Invoice charge line',
          filterType: 'Invoice',
          action: String(res[0].statement_no ?? ''),
          invoiceNo: Number(prop),
        });

        let inoviceData = {
          invoice_no: prop,
        };

        inoviceData = transformIntoApiCallObj(
          inoviceData,
          'get_invoice_details_m'
        );

        promiseArray.push(
          this.appService.AriaPassThroughConnect(inoviceData).toPromise()
        );
      }
    }

    const allPromise = Promise.all(promiseArray);

    allPromise
      .then((values) => {
        this.filterInvoiceData(values, constructInvoiceData);
      })
      .catch((error) => {
        
      });
  }

  filterInvoiceData(invoiceList: any[], constructInvoiceData: AccountBilling[]) {
    //
    for (let [index, invoiceDetails] of invoiceList.entries()) {
      let invoiceDesc = '';
      const uniquePlanNameHolder: string[] = [];
      if (
        invoiceDetails &&
        invoiceDetails.error_code === 0 &&
        invoiceDetails.error_msg === 'OK'
      ) {
        const rawInvoiceData: any[] = invoiceDetails.invoice_line_details;
        for (let invoiceIterator of rawInvoiceData) {
          if (invoiceIterator.plan_name) {
            if (!uniquePlanNameHolder.includes(invoiceIterator.plan_name)) {
              invoiceDesc = invoiceDesc + invoiceIterator.plan_name + ', ';
              uniquePlanNameHolder.push(invoiceIterator.plan_name);
            }
          }
        }
      }
      if (
        constructInvoiceData &&
        constructInvoiceData.length > 0 &&
        constructInvoiceData[index]
      ) {
        invoiceDesc = invoiceDesc.replace(/,\s*$/, '');
        // constructInvoiceData[index].desc = invoiceDesc
        constructInvoiceData[index].desc =
          '#' + constructInvoiceData[index].invoiceNo + ' ' + invoiceDesc;
      }
    }

    this.totalData.push(...constructInvoiceData);
    this.dateFilterClick();
    this.callPagerAndSort();
  }

  getRecord() {
    window.open('http://www.africau.edu/images/default/sample.pdf', '_blank');
  }

  dateFilterClick() {
    let selectedValue = this.filterForm.get('filter_prov')?.value;
    if (selectedValue == 'Custom Range') {
      this.openAdvancedFilters();
    } else {
      this.applyAdvanceFilters(this.appliedAdvanceFilters);
    }
  }

  openAdvancedFilters() {
    let ref = this.dialog.open(GdoAdvancedFilterationOptionsComponent, {
      // height: '72vh',
      // width: '58vw',
      panelClass: 'custom-modalbox-webview',
      data: this.appliedAdvanceFilters,
    });

    ref.afterClosed().pipe(take(1)).subscribe((selectedAdFilters) => {
      
      if (selectedAdFilters) {
        this.appliedAdvanceFilters = selectedAdFilters;
        this.applyAdvanceFilters(selectedAdFilters);
      }
    });
  }

  applyAdvanceFilters(filters: AppliedFilters | null) {
    // ;
    
    if (
      filters &&
      (filters.startDate ||
        filters.endDate ||
        filters.invoice ||
        filters.payment ||
        filters.credit ||
        filters.refund)
    ) {
      this.filteredData = this.totalData.filter((x: AccountBilling) => {
        if (
          filters.startDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) >=
            new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) <=
            new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.invoice &&
          x?.filterType?.toLowerCase() === 'invoice' &&
          filters.payment &&
          x?.filterType?.toLowerCase() === 'payment' &&
          filters.credit &&
          x?.filterType?.toLowerCase() === 'credit' &&
          filters.refund &&
          x?.filterType?.toLowerCase() === 'refund'
        ) {
          return true;
        }

        if (
          filters.startDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) >=
            new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) <=
            new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.payment &&
          x?.filterType?.toLowerCase() === 'payment'
        ) {
          return true;
        }

        if (
          filters.startDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) >=
            new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) <=
            new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.invoice &&
          x?.filterType?.toLowerCase() === 'invoice'
        ) {
          return true;
        }

        if (
          filters.startDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) >=
            new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) <=
            new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.credit &&
          x?.filterType?.toLowerCase() === 'credit'
        ) {
          return true;
        }

        if (
          filters.startDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) >=
            new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) <=
            new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.refund &&
          x?.filterType?.toLowerCase() === 'refund'
        ) {
          return true;
        }

        if (
          filters.startDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) >=
            new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate &&
          new Date(x.date!).setHours(0, 0, 0, 0) <=
            new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          !filters.invoice &&
          !filters.payment &&
          !filters.credit &&
          !filters.refund
        ) {
          return true;
        }

        if (
          !filters.startDate &&
          !filters.endDate &&
          filters.payment &&
          x?.filterType?.toLowerCase() === 'payment'
        ) {
          return true;
        }
        if (
          !filters.startDate &&
          !filters.endDate &&
          filters.invoice &&
          x?.filterType?.toLowerCase() === 'invoice'
        ) {
          return true;
        }

        if (
          !filters.startDate &&
          !filters.endDate &&
          filters.credit &&
          x?.filterType?.toLowerCase() === 'credit'
        ) {
          return true;
        }

        if (
          !filters.startDate &&
          !filters.endDate &&
          filters.refund &&
          x?.filterType?.toLowerCase() === 'refund'
        ) {
          return true;
        }

        return false;
      });
      this.callPagerAndSort();
    } else {
      let selectedValue = this.filterForm.get('filter_prov')?.value;
      if (selectedValue == 'Custom Range') {
        this.filteredData = this.totalData;
        this.callPagerAndSort();
      } else if (selectedValue == 'Last 6 Months') {
        this.filteredData = this.totalData.filter((x: AccountBilling) => {
          //
          if (this.getMonthDifference(x.date) < 6) {
            return true;
          }
          return false;
        });
        this.callPagerAndSort();
      } else if (selectedValue == 'Last Year') {
        this.filteredData = this.totalData.filter((x: AccountBilling) => {
          //
          let current = new Date(x.date!);
          let previous = new Date(x.date!);
          previous.setFullYear(previous.getFullYear() - 1);
          return current.getTime() > previous.getTime();
        });
        this.callPagerAndSort();
      }
    }
  }

  onApply() {
    let dialogRef = this.dialog.open(AdvancedFilterationOptionsComponent, {
      data: {},
    });

    dialogRef.componentInstance.onFilterApply.pipe(take(1)).subscribe(() => {
      // do something
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(() => { });
  }

  async viewInvoice(element: any, download: boolean) {
    let reqObj = {
      invoice_no: element.invoiceNo,
    };

    reqObj = transformIntoApiCallObj(reqObj, 'get_statement_for_invoice_m');
    const res = await this.appService
      .AriaPassThroughConnect(reqObj)
      .toPromise();

    if (
      res.error_code === 0 &&
      res.error_msg === 'OK' &&
      res.out_statement &&
      res.out_statement.length > 0
    ) {
      const htmlReport = res.out_statement;
      const passObj = {
        htmlReport: htmlReport,
        download: download,
        invoice_no: element.invoiceNo,
        statement_no: element.action // action is statment_no
      };

      if (window.innerWidth < 700) {
        this.viewReport = htmlReport;
        setTimeout(() => {
          let systemType = sessionState.getItem('systemType');
          // if (systemType && systemType == 'ios') {
          //   this.downloadForSmallScreensiOS(passObj);
          // } else {
          //   this.downloadForSmallScreens(passObj);
          // }
          this.appService.downloadPDF(passObj);
        }, 1000);
      } else {
        let ref = this.dialog.open(ViewInvoiceComponent, {
          height: '72vh',
          width: '58vw',
          data: passObj,
        });
      }
      // let ref = this.dialog.open(ViewInvoiceComponent, {
      //   height: '85vh',
      //   minWidth: '90wv',
      //   data: passObj,
      //   panelClass: 'testclass'
      // });
    }
  }

  formatDate(date: string | undefined) {
    const parsedDate = new Date(date ?? '');
    return (
      parsedDate.getMonth() +
      1 +
      '/' +
      parsedDate.getDate() +
      '/' +
      parsedDate.getFullYear()
    );
  }

  newDateT12(date: string | undefined) {
    const parsedDate = new Date((date ?? '') + 'T12:00:00');
    return (
      parsedDate.getMonth() +
      1 +
      '/' +
      parsedDate.getDate() +
      '/' +
      parsedDate.getFullYear()
    );
  }

  /**** ROW GROUPINGS ****/
  GroupRowBy(data: AccountBilling[]) {
    //makes an object and groups by date
    //
    const map: { [date: string]: AccountBilling[] } = {};

    data.forEach((item) => {
      //
      // const key = this.formatDate(item['date']);
      const key = this.newDateT12(item['date']);
      if (!map[key]) {
        map[key] = [];
        map[key].push(item);
        //map[key]= item;
      } else {
        map[key].push(item);
      }
    });
    //data tranformation: stores the key at the start of object
    Object.entries(map).forEach(([key, value]) => {
      //map[key].unshift(Object.assign(map,{Key:key}) as any) ;
      map[key].unshift({ key } as any);
      return map[key];
    });
    //changes into 1d array
    let groupArray = Object.keys(map).map((key) => map[key]);
    // let flatList = groupArray.reduce((a, c) => {
    //   return a.concat(c);
    // }, []);

    return groupArray;
  }
  //checks if the input is key then prints it in header section
  isGroup(index: number, item: AccountBilling & { key?: string }): boolean {
    return Boolean(item.key);
  }

  downloadForSmallScreensiOS(data: { invoice_no: string | number }) {
    const report = document.getElementById('download_invoice_report');
    if (!report) return;
    let html = report.outerHTML;

    // create the iframe
    let iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.display = 'block';
    iframe.style.position = 'absolute';
    iframe.style.top = window.innerHeight + 'px';

    document.body.appendChild(iframe);
    // add html to iframe
    iframe.srcdoc = html;

    let invoice_no = data.invoice_no;

    // wait for iframe to load
    iframe.addEventListener('load', () => {
      // use html2canvas to save the webpage
      let html2canvasOptions = {
        allowTaint: true,
        removeContainer: true,
        imageTimeout: 15000,
        logging: true,
        useCORS: true,
        scale: 2,
      };
      const frameBody = iframe.contentWindow?.document.body;
      if (!frameBody) {
        document.body.removeChild(iframe);
        return;
      }
      html2canvas(frameBody, html2canvasOptions).then(
        function (canvas) {
          document.body.removeChild(iframe);
          var imgWidth = 180;
          var pageHeight = 295;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;
          var heightLeft = imgHeight;

          const contentDataURL = canvas.toDataURL('image/png');
          let pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height]);
          var imgData = canvas.toDataURL('image/png', 1.0);
          pdf.addImage(imgData, 0, 0, canvas.width, canvas.height);
          // var position = 0;
          // pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST')
          // var data: any = document.getElementById('view_invoice_report');
          // document.body.removeChild(iframe)
          pdf.save(`${invoice_no}.pdf`); // Generated PDF
        }
      );
    });
  }

  downloadForSmallScreens(data: { invoice_no: string | number }) {
    // capture my on screen html

    const report = document.getElementById('download_invoice_report');
    if (!report) return;
    let html = report.outerHTML;

    // create the iframe
    let iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.alignItems = 'center';
    iframe.style.alignContent = 'center';
    iframe.style.display = 'block';
    iframe.style.position = 'absolute';
    iframe.style.top = window.innerHeight + 'px';

    document.body.appendChild(iframe);
    // add html to iframe
    iframe.srcdoc = html;

    let invoice_no = data.invoice_no;

    // wait for iframe to load
    iframe.addEventListener('load', () => {
      // use html2canvas to save the webpage
      let html2canvasOptions = {
        allowTaint: true,
        removeContainer: true,
        imageTimeout: 15000,
        logging: true,
        useCORS: true,
        scale: 2,
      };
      const frameBody = iframe.contentWindow?.document.body;
      if (!frameBody) {
        document.body.removeChild(iframe);
        return;
      }
      html2canvas(frameBody, html2canvasOptions).then(
        function (canvas) {
          document.body.removeChild(iframe);
          var imgWidth = 180;
          var pageHeight = 295;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;
          var heightLeft = imgHeight;

          // let pdf = new jsPDF('p', 'mm', [canvas.height, canvas.width]);
          // var imgData = canvas.toDataURL("image/png", 1.0);
          // pdf.addImage(imgData, 0, 0, canvas.width, canvas.height);

          var pdf = new jsPDF('p', 'mm', 'a4', true);
          var imgData = canvas.toDataURL('image/jpeg', 1.0);

          // due to lack of documentation; try setting w/h based on unit
          pdf.addImage(imgData, 'JPEG', 10, 10, imgWidth, imgHeight); // 180x

          pdf.save(`${invoice_no}.pdf`); // Generated PDF
        }
      );
    });
  }


  ResetFilters() {
    this.appliedAdvanceFilters = null;
    this.applyAdvanceFilters(this.appliedAdvanceFilters);
  }
}

export interface TransHistory {
  transaction_type?: number;
  transaction_desc?: string;
  transaction_amount?: number;
  transaction_currency?: string;
  transaction_create_date?: string;
  invoice_no?: number;
  transaction_id?: number;
  statement_no?: number;
  transaction_applied_amount?: number;
  transaction_source_id?: number;
  transaction_ref_code?: string;
  seq_statement_id?: string;
}
